import { Tab } from '@material-ui/core'
import { ContainerPage, TitlePage } from 'components'
import { ChangeEvent, useState } from 'react'

import CardContainerOrders from './components/CardContainerOrders'
import CardHistory from './components/CardHistory'
import { ContainerHeader, TabContainer } from './styles'

const Breaks = () => {
  const [tab, setTab] = useState(0)

  const onChangeTab = (event: ChangeEvent<{}>, newValue: number) => {
    setTab(newValue)
  }

  return (
    <>
      <ContainerPage>
        <ContainerHeader component="header">
          <TitlePage>Quebras</TitlePage>
        </ContainerHeader>
        <TabContainer value={tab} onChange={onChangeTab} centered tab={tab}>
          <Tab label="A liberar" />
          <Tab label="Histórico" />
        </TabContainer>
        {tab === 0 && <CardContainerOrders />}
        {tab === 1 && <CardHistory />}
      </ContainerPage>
    </>
  )
}

export default Breaks
